<template>
  <b-modal
      id="leaderboardModal"
      ref="leaderboardModal"
      size="lg"
      :hideHeader="true"
      :hideFooter="true"
      @shown="getTopTenStudent"
    >
    <button type="button" @click="hideModal" class="close" data-dismiss="modal" aria-label="Close">
                  <span :class="$route.query.lang =='ar'?'close-mark-ar':'close-mark'" aria-hidden="true">&times;</span>
                  </button>
     <div id="leaderboard-rank"> 
       <h1 style="color: #4AC1E0;"><img style="margin-right: 12px;" width="60" src="../../../../static/img/greeno.png">{{$t("message.leaderboard_modal.leaderboard_rank")}}<i class="fas fa-medal"></i>
         <img width="60" src="../../../../static/img/reddo.png"></h1>
          <table className="table">
            <tr>
              <th>{{$t("message.leaderboard_modal.rank")}}</th>
              <th>{{$t("message.leaderboard_modal.name")}}</th>
              <th >{{$t("message.leaderboard_modal.weekly_points")}}</th>
            </tr>
                <tr  v-for="(student,index) in students" :key="index">
                    <td > <i class="fas fa-trophy" style="margin-left: 5px; margin-right: 5px;"></i><span class="btn__badge">{{index+1}}</span></td>
                    <td v-if="student.student_name" class="text-center">{{student.student_name}}</td>
                    <td v-else class="text-center">{{student.username}}</td>
                   <td  v-if="student.points ==1">0</td> 
                   <td v-else>{{student.points}}</td> 
                  </tr>
                 
          </table>
        </div>
</b-modal>
</template>
<script>
import { eventBus } from "@/main";
export default {
  data(){
    return{
      students:[],
    }
  },
  mounted(){
  eventBus.$on('showTopModal', ()=>{
    this.$refs.leaderboardModal.show();
    });
  },
  methods:{
    hideModal(){
   this.$refs.leaderboardModal.hide();
    },
    getTopTenStudent(){
       this.$store.dispatch("getStudentsTopTen").then(
        res => {
          this.students = res.data.data.student_details;
        },
      ); 
    }
  }
    
}
</script>
<style scoped>
body {
	 background: #fafafa;
}
 #leaderboard-rank {
	 font-family: sans-serif;
	
}
 #leaderboard-rank h1 {
	 text-align: center;
	 margin-bottom: 0px;
}
 #leaderboard-rank table {
	 width: 100%;
	 border-spacing: 0 0;
	 background: #201645;
   color: white;
	 box-shadow: 0 0 20px #4AC1E0;
	 border-radius: 20px;
	 overflow: hidden;
}
 #leaderboard-rank table th {
   background: #251b4c;
	 border: none;
	 margin: 0;
	 padding: 0;
	 text-align: center;
	 padding: 20px 0px 20px 0px;
}
 #leaderboard-rank table th:first-of-type {
	 padding: 0 50px 0 30px;
   text-align: center;
}
 #leaderboard-rank table th:last-of-type {
	 padding: 0 10px 0 30px;
}
 #leaderboard-rank table th:nth-child(3), #leaderboard-rank table th:nth-child(4) {
	 text-align: center;
}
 #leaderboard-rank table tr:nth-child(2n+1) {
   background: #251b4c;
}
 #leaderboard-rank table tr td {
	 padding: 10px 0px;
}
 #leaderboard-rank table tr td:nth-child(1) {
	 padding: 10px 30px 10px 30px;
	 text-align: center;
}
 #leaderboard-rank table tr td:nth-child(3), #leaderboard-rank table tr td:nth-child(4) {
	 text-align: center;
}
 #leaderboard-rank a {
	 color: white;
	 text-decoration: none;
}
.btn__badge {
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 15px;
    background: #251b4b;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/leaderboard/leaderboardModal.vue